<script setup>
	import { ref, computed, onMounted, watch, nextTick } from 'vue';
	import { track_content_engagement } from 'shared/services/tracking/contentTrackingService';

	const props = defineProps({
		videoUrl: {
			type: String,
			default: '',
		},
		showVideo: {
			type: Boolean,
			default: true,
		},
		width: {
			type: Number,
			required: true,
		},
		height: {
			type: Number,
			required: true,
		},
		title: {
			type: String,
			default: '',
		},
	});

	const emit = defineEmits(['video-ended']);

	const videoIframe = ref(null);

	let videoApiIsReady = ref(false);
	let vimeoPlayer = null;

	onMounted(() => {
		if (!document.getElementById('videoapi-highlight')) {
			const videoApi = document.createElement('script');
			videoApi.src = 'https://player.vimeo.com/api/player.js';
			videoApi.async = true;
			videoApi.id = 'videoapi-highlight';

			const firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(videoApi, firstScriptTag);

			videoApi.onload = () => {
				nextTick(() => {
					videoApiIsReady.value = true;
				});
			};
		}
	});

	watch(
		() => videoApiIsReady.value,
		(videoApiIsReady) => {
			if (videoApiIsReady) {
				initializeVideo();
			}
		}
	);

	const initializeVideo = () => {
		vimeoPlayer = new Vimeo.Player(videoIframe.value);
		track_content_engagement('video', 'start', props.title || 'no_data', props.videoUrl);
		vimeoPlayer.on('ended', videoEnded);
	};

	const videoEnded = () => {
		emit('video-ended');
	};

	const vimeoVideoParams = computed(() => {
		let params = '?autoplay=1&controls=0&keyboard=0&muted=1&&byline=0&portrait=0&title=0';
		if (!window.marketingPermissions) {
			params += '&dnt=1';
		}
		return params;
	});

	const embedVideoId = computed(() => {
		const m = props.videoUrl.split('/');
		if (m) {
			return m[m.length - 1];
		}
	});

	const embedUrl = computed(() => {
		if (embedVideoId.value) {
			return `https://player.vimeo.com/video/${embedVideoId.value}${vimeoVideoParams.value}`;
		} else {
			return null;
		}
	});
</script>

<template>
	<iframe
		v-if="videoUrl"
		ref="videoIframe"
		:title="title"
		:src="embedUrl"
		:data-src="embedUrl"
		class="c-product-highlights__iframe"
		:width="width"
		:height="height"
	>
	</iframe>
</template>
